import * as React from 'react';
import { useTheme } from '@mui/material';

const CompletedTickCirle = () => {
    const theme = useTheme();
    const successColour = theme.colors.other.text.success;

    return (
        <svg width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle opacity={0.2} cx={16} cy={16} r={10} fill={successColour} />
            <path
                d="M27.92 14.667c.054.442.08.887.08 1.333A12 12 0 1 1 16 4c1.858.017 3.686.474 5.333 1.333"
                stroke={successColour}
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="m28 6.667-12 12-5.334-5.334"
                stroke={successColour}
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default CompletedTickCirle;
